import {
  DetectorPolicyBucket,
  PolicyLimitBuckets,
  PolicyLimitBucketsByUnit,
  ToolPolicySubFeature,
} from '~/services/toolPolicy/types';

const EMPTY_BUCKET: DetectorPolicyBucket = {
  total: 0,
  left: 0,
  entries: 0,
};

export const getOrCreateBucketsForUnit = (
  bucketsByUnit: PolicyLimitBucketsByUnit,
  unit: string,
): PolicyLimitBuckets => {
  if (!bucketsByUnit[unit]) {
    bucketsByUnit[unit] = createEmptyPolicyLimitBuckets();
  }

  return bucketsByUnit[unit];
};

export const createEmptyPolicyLimitBuckets = (): PolicyLimitBuckets => ({
  privateBucket: { ...EMPTY_BUCKET },
  sharedBucket: { ...EMPTY_BUCKET },
});

export const addSubFeatureToBucket = (
  bucket: DetectorPolicyBucket,
  subFeature: ToolPolicySubFeature,
): void => {
  const left = subFeature.remaining_amount ?? 0;
  // total_amount is optional on the response; fall back to `left` so capacity
  // never renders below remaining (or as NaN) when the field is absent.
  const total = subFeature.total_amount ?? left;

  bucket.left += left;
  bucket.total += total;
  bucket.entries += 1;
};
